export default "select * from information_schema.system_privileges\n"